<template>
  <v-container>
    <Waterfall :options="options">
      <WaterfallItem v-for="(item, index) in subimages" :key="index" class="col-lg-3 col-sm-4 col-6 item">
        <img  @click="openImg(index,$event)" :src="item.src"/>
      </WaterfallItem>
    </Waterfall>
    <ImageDialog :modalIsVisible="modalIsVisible" :modalContent="modalContent" :images="subimages" 
      :selectedIndex="selectedIndex" @closedialog="modalIsVisible = false"/> 
  </v-container>
</template>

<script>
  import {Waterfall, WaterfallItem} from 'vue2-waterfall';
  import ImageDialog from '@/components/ImageDialog';
  export default {
    name: 'Gallery',
    components: { 
      Waterfall,
      WaterfallItem,
      ImageDialog
    },
    data: () => ({
      images: {novias:[], tradicional:[],historia:[],looks:[],general:[],enzymo:[],pasarelas:[]},
      options: {},
      modalIsVisible: false,
      modalContent: "",
      selectedIndex: 0,
      subdirectory: "general",
      subimages: []
    }),
    watch:{
        $route (to){
            this.subdirectory = to.params.name;
            this.subimages = this.images[this.subdirectory];
        }
    },
    mounted() {
        this.subdirectory = this.$route.params.name;
        this.importAll(require.context('../assets/gallery/general', true, /\.jpg$/),'general');
        this.importAll(require.context('../assets/gallery/novias', true, /\.jpg$/),'novias');
        this.importAll(require.context('../assets/gallery/tradicional', true, /\.jpg$/),'tradicional');
        this.importAll(require.context('../assets/gallery/historia', true, /\.jpg$/),'historia');
        this.importAll(require.context('../assets/gallery/looks', true, /\.jpg$/),'looks');
        this.importAll(require.context('../assets/gallery/enzymo', true, /\.jpg$/),'enzymo');
        this.importAll(require.context('../assets/gallery/pasarelas', true, /\.jpg$/),'pasarelas');
        this.subimages = this.images[this.subdirectory];
    },
    methods: {
      importAll(r,dir) {
        r.keys().forEach(key => (this.images[dir].push({ src: r(key), name: key })));
      }, 
      openImg(index,event) {
        event.preventDefault();
        this.selectedIndex = index;
        this.modalContent = event.target.src;
        this.modalIsVisible = true;
      },
    },
  }
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
.item img {
  border-radius: 5px;
  display: block;
  width: 100%;
}
</style>